<app-booking-navbar [step]="3"></app-booking-navbar>

<div class="row mt-3" *ngIf="basket">
    <div class="col-12 text-right">
        <span class="mr-4" *ngIf="message" style="color: red; font-weight: bold;">{{message}}</span>


        <ng-container *ngIf="(booking$ | async).planSelected && !(roomInBasket$ | async)">
            <ng-container *ngIf="(availabilitySearch$ | async).hotel.id !== 'HOTEL005'">
                <!-- <button class="btn btn-primary" (click)="addToBasket()">Book now</button> -->
                <!-- <button (click)="addToBasket()" class="btn btn-sm btn-primary">Continue</button> -->

                <button *ngIf="!(booking$ | async).planSelected.allowAdditionalNights" class="btn btn-sm btn-primary" (click)="addToBasket()">Continue</button>
                <button *ngIf="(booking$ | async).planSelected.allowAdditionalNights" class="btnbtn-sm btn-primary" (click)="triggerAdditionalNights()">Continue</button>

            </ng-container>
            <ng-container *ngIf="(availabilitySearch$ | async).hotel.id === 'HOTEL005'">
                <button *ngIf="!(availabilitySearch$ | async).room.allowSpa && !(booking$ | async).planSelected.triggerSpa && (booking$ | async).planSelected.ratePlanCode !== 'FFCRU'" class="btn btn-sm  btn-primary" (click)="addToBasket()">Continue</button>
                <button *ngIf="!(availabilitySearch$ | async).room.allowSpa && (booking$ | async).planSelected.triggerSpa" class="btn btn-sm  btn-primary"  (click)="triggerGuests()">Continue</button>
                <button *ngIf="(availabilitySearch$ | async).room.allowSpa || (booking$ | async).planSelected.ratePlanCode === 'FFCRU'" class="btn btn-sm  btn-primary"  (click)="triggerGuests()">Continue</button>
            </ng-container>
                <!-- <button class="btn btn-primary"  (click)="triggerGuests()">Book spa now</button> -->
        </ng-container>

    </div>
</div>
<div class="row h-100 mt-3" *ngIf="basket">
    <div class="col-6">

        <mat-card class="margin-bottom-30">
            <mat-card-content>
                <h2 class="mat-title mb-2">Booker Details

                    <a class="hover" (click)="toggleUserModal()">
                        <i class="fa fa-edit"></i>
                    </a>
                </h2>

                <div class="row mb-2">
                    <div class="col-6">
                        <p class="mb-0">{{basket.user.firstname}} {{basket.user.surname}}</p>
                        <p class="mb-0">{{basket.user.username}}</p>
                        <p class="mb-4">{{basket.user.telephone}}</p>
                        <p class="mb-4">Passport number: {{basket.user.cardNumber}}</p>
                    </div>
                    <div class="col-6">
                        <p class="mb-0" *ngIf="basket.user.add1">{{basket.user.add1}}</p>
                        <p class="mb-0" *ngIf="basket.user.add2">{{basket.user.add2}}</p>
                        <p class="mb-0" *ngIf="basket.user.add3">{{basket.user.add3}}</p>
                        <p class="mb-0" *ngIf="basket.user.town">{{basket.user.town}}</p>
                        <p class="mb-0" *ngIf="basket.user.county">{{basket.user.county}}</p>
                        <p class="mb-0" *ngIf="basket.user.postcode">{{basket.user.postcode}}</p>

                    </div>
                </div>


                <h2 class="mat-title mb-2">Guest Details</h2>

                <div class="mt-2">
                    <ng-container *ngFor="let g of guests; let i = index">
                        <p class="mb-0">Guest {{i + 1}}</p>
                        <div class="row mb-2">
                            <div class="col-xl-4 pr-1">
                                <input class="form-control form-control-sm" [(ngModel)]="g.firstname" placeholder="First name">
                            </div>
                            <div class="col-xl-4 pr-1 pl-1">
                                <input class="form-control form-control-sm" [(ngModel)]="g.surname" placeholder="Surname">
                            </div>
                            <div class="col-xl-4 pr-1 pl-1">
                                <input class="form-control form-control-sm" [(ngModel)]="g.email" placeholder="Email">
                            </div>
                        </div>

                    </ng-container>
                </div>

            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-content *ngIf="(availabilitySearch$ | async)">
                <h2 class="mat-title mb-2">Room Overview</h2>
                <p class="mb-0">{{(availabilitySearch$ | async).hotel.name}} - {{(availabilitySearch$ | async).room.name}}</p>
                <p class="mb-0">Check-in: {{(availabilitySearch$ | async).checkIn | date: 'dd/MM/yyyy'}}</p>

                <p class="mb-0">Nights: {{(availabilitySearch$ | async).nights}}</p>
                <p class="mb-0">Adults: {{(availabilitySearch$ | async).adults}}</p>
                <p class="mb-0">Children: {{(availabilitySearch$ | async).children}}</p>

            </mat-card-content>
        </mat-card>

    </div>
    <div class="col-6">
        <mat-card class="margin-bottom-30">
            <mat-card-content>
                <h2 class="mat-title mb-2">Select rate</h2>
                <table class="table table-sm">
                    <tr *ngFor="let ratePlan of ratePlans">

                        <td align="left">
                            <p class="mb-0 fs-5 fs-regular">
                                {{ratePlan.name}}
                                <a (click)="viewRate(ratePlan)" class="mb-2 hover">
                                    <i class="fa fa-info-circle"></i>
                                </a>

                            </p>
                        </td>
                        <td align="left">
                            <p class="mb-0 fs-5 fs-regular" *ngIf="basket && !basket.user.isGuest">{{ratePlan.costs.costPassport.costOfStay | currency : 'GBP'}}</p>
                            <p class="mb-0 fs-5 fs-regular" *ngIf="basket && basket.user.isGuest">{{ratePlan.costs.costStandard.costOfStay | currency : 'GBP'}}</p>
                        </td>
                        <td align="right">
                            <ng-container *ngIf="(booking$ | async).planSelected">
                                <button type="button" *ngIf="ratePlan.id === planSelected?.id || (booking$ | async).planSelected && (booking$ | async).planSelected.id === ratePlan.id" class="btn btn-sm btn-primary" (click)="selectRatePlan(ratePlan)">
                                    <i class="fa fa-check"></i>
                                </button>
                                <button type="button" *ngIf="ratePlan.id !== planSelected?.id  && (booking$ | async).planSelected && (booking$ | async).planSelected.id !== ratePlan.id" class="btn btn-sm btn-light" (click)="selectRatePlan(ratePlan)">
                                    <i class="fa fa-check"></i>
                                </button>
                            </ng-container>
                            <ng-container *ngIf="!(booking$ | async).planSelected">
                                <button type="button" class="btn btn-sm btn-light" (click)="selectRatePlan(ratePlan)">
                                    <i class="fa fa-check"></i>
                                </button>

                            </ng-container>

                        </td>
                    </tr>

                </table>
                <div class="alert alert-warning" *ngIf="showRateUpsellText">
                    <p class="mb-0">One or more of the available rates has a special offer,  please review and make the customer aware</p>
                </div>
            </mat-card-content>
        </mat-card>

        <mat-card>
            <mat-card-content>
                <h2 class="mat-title mb-2">Add Ons</h2>
                <app-add-ons [addOns]="addOns"></app-add-ons>
            </mat-card-content>

        </mat-card>

    </div>
</div>
<app-availability-additional-nights *ngIf="showAdditionalNight" [ratePlan]="(booking$ | async).planSelected" (emitResult)="closeAdditionalNights($event)"></app-availability-additional-nights>

<app-booking-rate-info *ngIf="(overlays$ | async).ratePlanInfo" [ratePlan]="(infoPlan$ | async)" [basket]="basket"></app-booking-rate-info>
<app-trybe-package-select-item *ngIf="showPackageModel" [dateSelected]="trybeDate" (cancelled)="killTryBe()" (itemAdded)="packageAdded($event)"></app-trybe-package-select-item>
<app-booking-user-modal *ngIf="basket && userModal" [passportId]="basket.user.id" (cancelEdit)="toggleUserModal()" (close)="toggleUserModal()" (savedUser)="savedUser()"></app-booking-user-modal>

<app-spa-guests *ngIf="showGuestModal" [totalGuests]="+(availabilitySearch$ | async).adults" (complete)="guestsAdded($event)"></app-spa-guests>
<app-processing-modal *ngIf="processingBooking"  [title]="'Please wait whilst your FFOLKESPA booking is created. Do not refresh the page.'"></app-processing-modal>
